import React from "react";

const ContactField = () => {
    return (
        <div className="link-to-mail-container animate-fade-left">
            <a className="link-to-mail" href="mailto:yozu.codes@gmail.com">
                <span className="mail-icon"><ion-icon name="mail"></ion-icon></span>
                <span className="mail-open-icon"><ion-icon name="mail-open"></ion-icon></span>
                <span>Yozu Codes</span>
            </a>
        </div>
    );
};

export default ContactField;
